document.addEventListener("DOMContentLoaded", () => {

    const HEADER_OFFSET = 0;

    // =========================
    // Smooth scroll click
    // =========================
    document.querySelectorAll('a[href*="?scroll="], a[href^="#"]').forEach(link => {

        link.addEventListener("click", function(e){

            const href = this.getAttribute("href");

            if(!href) return;

            let targetId = "";

            if(href.includes("?scroll=")){

                const url = new URL(href, window.location.origin);

                targetId = url.searchParams.get("scroll");

            }
            else if(href.startsWith("#")){

                targetId = href.replace("#","");

            }

            if(!targetId) return;

            const target = document.getElementById(targetId);

            if(!target) return;

            e.preventDefault();

            scrollToTarget(target);

            history.pushState(
                {},
                "",
                window.location.pathname + "?scroll=" + targetId
            );

        });

    });

    // =========================
    // Scroll on page load
    // =========================
    window.addEventListener("load", () => {

        const params = new URLSearchParams(window.location.search);

        const scrollTarget = params.get("scroll");

        if(!scrollTarget) return;

        const target = document.getElementById(scrollTarget);

        if(!target) return;

        waitAndScroll(target);

    });

    // =========================
    // Wait until layout stable
    // =========================
    function waitAndScroll(target){

        let attempts = 0;

        const interval = setInterval(() => {

            scrollToTarget(target);

            attempts++;

            // stop after ~2s
            if(attempts > 10){

                clearInterval(interval);

            }

        }, 200);

    }

    // =========================
    // Scroll function
    // =========================
    function scrollToTarget(target){

        const top =
            target.getBoundingClientRect().top +
            window.pageYOffset -
            HEADER_OFFSET;

        window.scrollTo({
            top,
            behavior: "smooth"
        });

    }

    // =========================
    // Animation section
    // =========================
    const items = document.querySelectorAll(".gp-animate");

    items.forEach(el => {

        const anim = el.dataset.anim || "fade";
        const trigger = el.dataset.trigger || "appear";
        const speed = el.dataset.speed || "1";

        // add animation class
        el.classList.add(`anim-${anim}`);

        // speed
        el.style.setProperty("--speed", `${speed}s`);

        // =========================
        // WHEN APPEAR
        // =========================
        if(trigger === "appear"){

            const observer = new IntersectionObserver(entries => {

                entries.forEach(entry => {

                    if(entry.isIntersecting){
                        el.classList.add("active");
                    }else{
                        el.classList.remove("active");
                    }

                });

            }, {
                threshold: 0.2
            });

            observer.observe(el);
        }

        // =========================
        // WHEN HOVER
        // =========================
        if(trigger === "hover"){

            el.addEventListener("mouseenter", () => {

                el.classList.remove("active");

                void el.offsetWidth;

                el.classList.add("active");

            });

        }

    });

    // =========================
    // Sidebar button
    // =========================
    const openButtons = document.querySelectorAll('.open-sidebar-button');
    const closeButtons = document.querySelectorAll('.close-sidebar-button');
    const overlay = document.querySelector('.luxury-overlay');

    openButtons.forEach(button => {

        button.addEventListener('click', function(){

        const targetSidebar = document.getElementById(
            this.dataset.sidebar
        );

        document
            .querySelectorAll('.luxury-sidebar')
            .forEach(sidebar => {
            sidebar.classList.remove('active');
            });

        targetSidebar.classList.add('active');

        overlay.classList.add('active');

        });

    });

    closeButtons.forEach(button => {

        button.addEventListener('click', function(){

        this.closest('.luxury-sidebar')
            .classList.remove('active');

        overlay.classList.remove('active');


        });

    });

    overlay.addEventListener('click', function(){

        document
        .querySelectorAll('.luxury-sidebar')
        .forEach(sidebar => {
            sidebar.classList.remove('active');
        });

        overlay.classList.remove('active');

    });

});